module.exports = __webpack_public_path__ + "img/healthy_public_img.b9b58796.gif";